import { Card, CardBody, Stack, Text } from '@chakra-ui/react';
import { Show } from '@pelicargo/ui';

import { useCurrentDraft } from '../../../hooks/useCurrentDraft';
import { AppliedSummary } from './AppliedSummary';
import { LinkageCard } from './LinkageCard';
import { readApplySummary, readBookingPayload } from './payload';
import { ReviewAlerts } from './ReviewAlerts';
import { SegmentsTable } from './SegmentsTable';

/**
 * Review view for a booking-confirmation draft: what the deterministic matcher resolved the email to — which request,
 * carrier and quote — and which flights the carrier confirmed, each labelled against the quote's own flight path.
 * Which legs an apply would fill or reroute is already in the table's tags, so nothing here restates it. What an
 * apply DID write closes the section, under the flights it wrote.
 */
export const BookingConfirmationSection = () => {
  const { draft } = useCurrentDraft();
  if (!draft) return null;

  const booking = readBookingPayload(draft.payload);
  const applied = readApplySummary(draft.applied_summary);

  return (
    <Stack spacing="4">
      <LinkageCard booking={booking} />

      <Show if={!!booking && booking.segments.length > 0}>
        <Card variant="outline">
          <CardBody px="0" py="2">
            <SegmentsTable segments={booking?.segments ?? []} />
          </CardBody>
        </Card>
      </Show>

      <Show if={!!booking?.notes}>
        <Text fontSize="sm" color="gray.600">
          {booking?.notes}
        </Text>
      </Show>

      <ReviewAlerts booking={booking} />

      <Show if={!!applied}>
        <AppliedSummary applied={applied} />
      </Show>
    </Stack>
  );
};
